import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UsuarioDerivacionDto, UsuarioDto } from '../../models/usuario-dto.model';
import { Sender } from '../../models/sender.model';
import { Rol } from '../../models/rol.model';

export interface FrontendUpdateAckResponse {
  requiereRecargaFrontend: boolean;
  nombreUsuario: string;
}

export interface GestionTicketCredentialStatus {
  configured: boolean;
  gestionTicketSsoId?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class UserServiceService {
  private apiUrl: string = environment.apiUrl;

  constructor(private http: HttpClient) { }

  crearUsuario(user: UsuarioDto): Observable<UsuarioDto> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<UsuarioDto>(
      `${this.apiUrl}/newUser/crearUsuario`,
      user, { headers }
    );
  }

  getUsuario(username: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/user/getUsuario/${username}`, {
      headers: { 'Content-Type': 'application/json' },
      observe: 'response',
      responseType: 'json'
    });
  }

  getCliente(wa_id: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/client/getCliente/${wa_id}`, {    
      headers: { 'Content-Type': 'application/json' },
      observe: 'response',
      responseType: 'json'
    });
  }

  getAllUsuarios(): Observable<UsuarioDto[]> {
    return this.http.get<UsuarioDto[]>(`${this.apiUrl}/user/getAllUsuarios`);
  }

  getUsuariosParaDerivacion(): Observable<UsuarioDerivacionDto[]> {
    return this.http.get<UsuarioDerivacionDto[]>(`${this.apiUrl}/derivacion/usuarios`);
  }

  getRoles(): Observable<Rol[]> {
    return this.http.get<Rol[]>(`${this.apiUrl}/roles`);
  }

  modificarUsuario(usuario: UsuarioDto): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http.post<UsuarioDto>(
      `${this.apiUrl}/user/modificarUsuario`, usuario, { headers });
  }

  actualizarPerfilPropio(nombreCompleto: string, email: string): Observable<UsuarioDto> {
    return this.http.put<UsuarioDto>(`${this.apiUrl}/user/me/profile`, {
      nombreCompleto,
      email,
    });
  }

  cambiarContrasenaPropia(contrasenaActual: string, nuevaContrasena: string): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/user/me/password`, {
      contrasenaActual,
      nuevaContrasena,
    });
  }

  guardarCliente(cliente: Sender): Observable<Sender> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<Sender>(
      `${this.apiUrl}/client/guardarCliente`, cliente, { headers }
    );
  }


  obtenerUsuarioLogeado(): Observable<UsuarioDto> {
    return this.http.get<UsuarioDto>(
      `${this.apiUrl}/user/obtenerUsuarioLogeado`);
  }

  getGestionTicketCredentials(): Observable<GestionTicketCredentialStatus> {
    return this.http.get<GestionTicketCredentialStatus>(`${this.apiUrl}/user/me/gestion-ticket-credentials`);
  }

  saveGestionTicketCredentials(password: string): Observable<GestionTicketCredentialStatus> {
    return this.http.put<GestionTicketCredentialStatus>(`${this.apiUrl}/user/me/gestion-ticket-credentials`, { password });
  }

  deleteGestionTicketCredentials(): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/user/me/gestion-ticket-credentials`);
  }

  ackFrontendUpdate(): Observable<FrontendUpdateAckResponse> {
    return this.http.post<FrontendUpdateAckResponse>(
      `${this.apiUrl}/user/frontend-update/ack`,
      null,
    );
  }

  recuperarUsuario(email: string) {
    return this.http.get(`${this.apiUrl}/login/recuperarUsuarioMail`, {
      params: { email }, responseType: 'text'
    });
  }

  recuperarContrasena(usuario: string) {
    return this.http.get(`${this.apiUrl}/login/recuperarContrasena`, {
      params: { usuario }, responseType: 'text'
    });
  }

  reiniciarContrasena(token: string, nuevaContrasena: string) {
    return this.http.post(`${this.apiUrl}/login/reiniciarContrasena`, { token, nuevaContrasena }, {
      responseType: 'text'
    });

  }

  limpiarContrasena(usuario: UsuarioDto): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(`${this.apiUrl}/user/limpiarContrasena`, usuario, { headers });
  }
}

